/**
 * EpicRow — DS Pattern
 */

import { Badge } from '../../atoms';
import { ProgressBar } from '../../molecules';
import styles from './EpicRow.module.css';

interface EpicRowProps {
  name: string;
  sprint: string;
  done: number;
  total: number;
  tags?: string[];
  className?: string;
}

export function EpicRow({ name, sprint, done, total, tags = [], className = '' }: EpicRowProps) {
  const pct = total > 0 ? Math.round((done / total) * 100) : 0;
  return (
    <div className={`${styles.row} ${className}`}>
      <div className={styles.main}>
        <div className={styles.nameRow}>
          <span className={styles.name}>{name}</span>
          <Badge variant="neutral">{sprint}</Badge>
          {tags.map(t => <Badge key={t} variant="primary">{t}</Badge>)}
        </div>
        <ProgressBar value={pct} showPercent variant={pct === 100 ? 'action' : 'primary'} />
      </div>
      <div className={styles.pts}>
        <span className={styles.done}>{done}</span>
        <span className={styles.sep}>/</span>
        <span className={styles.total}>{total} pts</span>
      </div>
    </div>
  );
}
